import React, { useState } from 'react';

import {
  Form,
} from '@edx/paragon';
import PropTypes from 'prop-types';

const FormGroup = (props) => {
  const [hasFocus, setHasFocus] = useState(false);

  const handleFocus = (e) => {
    setHasFocus(true);
    if (props.handleFocus) { props.handleFocus(e); }
  };
  const handleClick = (e) => {
    if (props.handleClick) { props.handleClick(e); }
  };
  const handleOnBlur = (e) => {
    setHasFocus(false);
    if (props.handleBlur) { props.handleBlur(e); }
  };

  const hasError = Boolean(props.errorMessage);

  return (
    <Form.Group
      controlId={props.name}
      className={`position-relative form-field ${hasError ? 'has-error' : ''} form-type ${props.className}`}
      isInvalid={props.errorMessage !== ''}
    >
      {props.floatingLabel && (
        <Form.Label
          className={`form-fields-label regular-text ml-3 mb-0 ${props.borderClass} ${props.value ? 'visible' : 'hidden'}`}
        >
          {props.floatingLabel}
        </Form.Label>
      )}
      {props.absoluteLabel && (
        <Form.Label
          className={`form-fields-label ${props.borderClass} ${props.value ? 'visible' : 'hidden'}`}
        >
          {props.absoluteLabel}
        </Form.Label>
      )}
      <Form.Control
        as={props.as}
        readOnly={props.readOnly}
        type={props.type}
        aria-invalid={props.errorMessage !== ''}
        className={`form-group__form-field ${props.inputClassName || ''}`}
        autoComplete={props.autoComplete}
        spellCheck={props.spellCheck}
        name={props.name}
        value={props.value}
        style={props.inputStyle}
        onFocus={handleFocus}
        onBlur={handleOnBlur}
        onClick={handleClick}
        onChange={props.handleChange}
        trailingElement={props.trailingElement}
        placeholder={props.placeholder}
        isInvalid={hasError}
      >
        {props.options ? props.options() : null}
      </Form.Control>
      {props.bottomLabel && !props.errorMessage && (
        <span className="label-text-small mt-1">{props.bottomLabel}</span>
      )}
      <div className={`${hasFocus && props.helpText.length > 0 ? 'mt-2' : ''}`}>
        {hasFocus && props.helpText.length > 0 ? (
          <Form.Control.Feedback
            type="default"
            key="help-text"
            className={`${
              props.helpText.length > 0 ? '' : 'hidden'
            } form-text-size label-text-small p-1 tip tip-input`}
          >
            {props.helpText.map((message, index) => (
              <span key={`help-text-${index.toString()}`}>
                {message}
                <br />
              </span>
            ))}
          </Form.Control.Feedback>
        ) : (
          <div key="empty" />
        )}
      </div>
      <Form.Control.Feedback
        key="error"
        className="form-text-invalid"
        hasIcon={false}
        feedback-for={props.name}
        type="invalid"
      >
        <p>{props.errorMessage || "\u00A0"}</p>
      </Form.Control.Feedback>
      {props.children}
    </Form.Group>
  );
};

FormGroup.defaultProps = {
  inputClassName: '',
  as: 'input',
  autoComplete: null,
  borderClass: '',
  children: null,
  className: '',
  errorMessage: '',
  handleBlur: null,
  handleChange: () => {},
  handleClick: null,
  handleFocus: null,
  floatingLabel: '',
  absoluteLabel: '',
  placeholder: '',
  bottomLabel: '',
  inputStyle: {},
  helpText: [],
  options: null,
  readOnly: false,
  spellCheck: null,
  showErrorMessage: false,
  trailingElement: null,
  type: 'text',
};

FormGroup.propTypes = {
  as: PropTypes.string,
  autoComplete: PropTypes.string,
  borderClass: PropTypes.string,
  children: PropTypes.element,
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  floatingLabel: PropTypes.string,
  absoluteLabel: PropTypes.string,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  handleClick: PropTypes.func,
  handleFocus: PropTypes.func,
  helpText: PropTypes.arrayOf(PropTypes.string),
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  bottomLabel: PropTypes.string,
  inputStyle: PropTypes.shape({}),
  options: PropTypes.func,
  readOnly: PropTypes.bool,
  spellCheck: PropTypes.string,
  trailingElement: PropTypes.element,
  showErrorMessage: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
  inputClassName: PropTypes.string,
};

export default FormGroup;
